<template>
	<div id='dom' class="page" :style="[pageDiv]">
		<Tip :tip="tip" />
		<div class="from_div" :style="[fromDiv]">
			<el-form ref="form" :model="form" label-position="left" label-width="120px">
				<el-form-item label="访问时间：" prop="visit_time">
					<el-date-picker class="input" v-model="form.visit_time" type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" />
				</el-form-item>
				<el-form-item label="客户名称：" prop="consumer_id">
					<el-select class="select" :disabled="(typeof(this.type) !== 'undefined') ? true : false"
						v-model="form.consumer_id" clearable placeholder="选择客户名称">
						<el-option v-for="item in consumerList" :key="item.consumer_id" :label="item.consumer_name"
							:value="item.consumer_id" />
					</el-select>
				</el-form-item>
				<el-form-item label="客户被访人：" prop="visit_object">
					<el-input class="input" v-model="form.visit_object" placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="被访人职务：" prop="visit_duty">
					<el-input class="input" v-model="form.visit_duty" placeholder="请输入内容" />
				</el-form-item>
				<div class="row">
					<el-form-item label="跟进人员：" prop="admin_id" style="margin-bottom: 10px;">
						<el-select class="select" v-model="form.admin_id" clearable placeholder="选择跟进人员">
							<el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name"
								:value="item.admin_id" />
						</el-select>
					</el-form-item>
					<el-form-item label="陪同人员：" prop="entourage_id" label-width="90px" style="margin-bottom: 10px;">
						<el-select class="select" v-model="form.entourage_id" clearable placeholder="选择陪同人员">
							<el-option v-for="item in adminList" :key="item.admin_id" :label="item.nick_name"
								:value="item.admin_id" />
						</el-select>
					</el-form-item>
				</div>
				<el-form-item label="跟进方式：" prop="visit_method" style="margin-bottom: 10px;">
					<el-radio-group v-model="form.visit_method">
						<el-radio :label="1">上门拜访</el-radio>
						<el-radio :label="2">电话拜访</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="跟进内容：" prop="visit_content">
					<el-input class="input_" v-model="form.visit_content" placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="客户回馈：" prop="visit_feedback">
					<el-input class="input_" v-model="form.visit_feedback" placeholder="请输入内容" />
				</el-form-item>
				<el-form-item label="过程拍照：" style="margin-bottom: 0;">
					<multiUpload :type='0' :limitImg='100' :noneBtnImg='visitImgList.length > 0' :fileList="visitImgList"
						@saveImg="saveImg" @delImg="delImg" />
				</el-form-item>
			</el-form>
		</div>
		<div class="foot_div" :style="[footDiv]">
			<el-button v-if="(typeof(this.type) !== 'undefined')" @click="close">返回</el-button>
			<el-button type="primary" @click="submitForm('form')">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import multiUpload from "../../../components/multiUpload/multiUpload.vue"
	import {
		mapGetters
	} from 'vuex';
	import {
		adminLists,
		consumerLists,
		consumerVisit
	} from "../../../request/apis.js"
	export default {
		props: {
			type: {
				type: Number
			}
		},
		components: {
			Tip,
			multiUpload
		},
		data() {
			return {
				tip: '客户走访过程记录。',
				consumerList: [], //客户列表
				adminList: [], //管理人员列表
				visitImgList: [], //拍照过程
				form: {
					visit_time: '', //拜访时间
					consumer_id: '', //客户id
					visit_object: '', //拜访对象
					visit_duty: '', //职务
					admin_id: '', //拜访人id
					entourage_id: '', //陪同人id
					visit_method: '', //拜访方式 1=上门拜访,2=电话拜访
					visit_content: '', //拜访内容
					visit_feedback: '', //回馈
					visit_imgs: [] //拍照
				},
				page: 1, //当前页 刷新后默认显示第一页
				limit: 10, //每一页显示的数据量 此处每页显示10条数据
				total: 0, //总条数
			}
		},
		computed: {
			pageDiv() {
				return {
					'position': typeof(this.type) !== 'undefined' ? 'relative' : ''
				}
			},
			fromDiv() {
				return {
					'overflow': typeof(this.type) !== 'undefined' ? 'scroll' : '',
					'height': typeof(this.type) !== 'undefined' ? '620px' : '',
					'min-height': typeof(this.type) !== 'undefined' ? '100%' : '',
					'padding-bottom': typeof(this.type) !== 'undefined' ? '66px' : '',
				}
			},
			footDiv() {
				return {
					'margin-left': typeof(this.type) !== 'undefined' ? '' : '66px'
				}
			},
			...mapGetters(['loginInfo']),
		},
		mounted() {
			if (typeof(this.type) !== 'undefined') {
				this.form.consumer_id = this.type
			}
			this.getConsumerList();
			this.getAdminList();
			this.$watermark.set(this.loginInfo.nick_name + '-' + this.loginInfo.phone.substr(this.loginInfo.phone.length-4), dom);
		},
		methods: {

			//获取客户列表
			getConsumerList() {
				consumerLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.total = res.count
						this.consumerList = res.data
					}
				}).catch(err => {})
			},

			//获取管理人员列表
			getAdminList() {
				adminLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code == 0) {
						this.adminList = res.data;
					}
				}).catch(err => {})
			},

			//图片存储
			saveImg(arr) {
				//过程拍照
				this.form.visit_imgs.push(arr[0]);
			},

			//图片删除
			delImg(arr) {
				//过程拍照
				this.form.visit_imgs.splice(arr[0], 1)
			},

			//提交表单
			submitForm(form) {
				this.$refs[form].validate((valid) => {
					if (valid) {
						consumerVisit({
							...this.form
						}).then(res => {
							if (res.code == 0) {
								this.visitImgList = []
								this.$message.success(res.msg);
								this.$refs[form].resetFields();
								if (typeof(this.type) !== 'undefined') {
									this.$emit('close', 0)
								} else {
									this.$router.push('/archivesList')
								}
							}else{
								this.$message.error(res.msg);
							}
						}).catch(err => {})
					} else {
						return false;
					}
				});
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		min-height: -webkit-fill-available;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
	}

	.input {
		width: 200px;
		margin-right: 25px;
	}

	.input_s {
		width: 130px;
	}

	.input_ {
		width: 435px;
	}

	.add_div {
		display: flex;
		flex-direction: column;
	}

	.item_div {
		display: flex;
		flex-direction: row;
		margin-bottom: 22px;
	}

	.select {
		width: 137px;
		margin-right: 90px;
	}

	.upload_div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 90px;
		height: 90px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
	}

	.upload_div_ {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 160px;
		height: 90px;
		background-color: #fbfdff;
		border: 1px dashed #c0ccda;
		border-radius: 6px;
		margin-right: 25px;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #606266;
		margin-left: 100px;
	}

	.span_ {
		font-size: 12px;
		font-weight: normal;
		line-height: normal;
		color: #767676;
		margin-top: 5px;
	}

	.el-icon-plus {
		font-size: 20px;
		font-weight: bolder;
		color: #606266;
	}

	/deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
		content: '※';
		color: #EA0000;
		font-size: 12px;
		margin-right: 4px;
	}
</style>